import { addDays, format } from 'date-fns';
import { allDatesFormat } from 'common/dateFormatConfig';

export const getNextDay = (day, dateFormat = allDatesFormat[0]) =>
  format(addDays(day, 1), dateFormat);
